import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledCardRows = styled(Flex)`
  display: flex;
  flex-direction: column;
  gap: ${(props): string => props.theme.kcc.spacing.XS};

  .card-rows__title {
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    margin-bottom: 0;
  }

  .card-rows__row {
    display: flex;
    align-items: flex-start;
  }

  .card-rows__label {
    flex: 1;
    min-width: 0;
  }

  .card-rows__value {
    flex: 1;
    min-width: 0;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.BOLD};
    text-align: right;
    word-break: break-word;
    overflow-wrap: break-word;
  }
`;
